import { v4 as uuidv4 } from "uuid";
import axios from "axios";
import { ABMD_PUBLIC_KEY, CLIENT_Id, CLIENT_SECRET } from "../apiConfig";

// export const encryptString = async (plainText) => {

//     try {
//         const keyData = ABMD_PUBLIC_KEY
//             .replace(/-----BEGIN PUBLIC KEY-----/, "")
//             .replace(/-----END PUBLIC KEY-----/, "")
//             .replace(/\n/g, "");
//         const binaryDer = Uint8Array.from(atob(keyData), (c) => c.charCodeAt(0));
//         const publicKey = await window.crypto.subtle.importKey(
//             "spki",
//             binaryDer.buffer,
//             {
//                 name: "RSA-OAEP",
//                 hash: { name: "SHA-1" },
//             },
//             true,
//             ["encrypt"]
//         );

//         const encoder = new TextEncoder();
//         const encodedData = encoder.encode(plainText);
//         const encryptedData = await window.crypto.subtle.encrypt(
//             { name: "RSA-OAEP" },
//             publicKey,
//             encodedData
//         );

//         const encryptedBase64 = btoa(
//             String.fromCharCode(...new Uint8Array(encryptedData))
//         );
//         return encryptedBase64;
//     } catch (err) {
//         console.error("Encryption Error:", err);
//         throw new Error("Failed to encrypt string.");
//     }
// };

export const encryptString = async (plaintext) => {
    try {
        if (!plaintext) {
            throw new Error('Plaintext is required for encryption');
        }
 
        const response = await axios.post("/nodeapi/abdm/encrypt", {
            plaintext: plaintext.toString()
        });
 
        if (!response.data?.success || !response.data?.encryptText) {
            throw new Error(response?.data?.message || 'Failed to encrypt data');
        }
        return response.data.encryptText;
    } catch (error) {
        throw new Error(error?.response?.data?.message || error?.message || 'Encryption failed');
    }
};


export const createSession = async () => {
    const Backend_token = localStorage.getItem('Backend_token');
    try {
        const response = await axios.post(
            "/abdm/sessions",
            {
                request: {
                    clientId: CLIENT_Id,
                    clientSecret: CLIENT_SECRET,
                    grantType: "client_credentials",
                },
                header: {
                    "Content-Type": "application/json",
                    "REQUEST-ID": uuidv4(),
                    "TIMESTAMP": new Date().toISOString(),
                    "X-CM-ID": "sbx",
                },

            },
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${Backend_token}`,
                },
            }
        );
        return response.data;
    } catch (error) {
        console.error("Session Creation Error:", error);
        throw new Error("Failed to create session.");
    }
};

export const getAbhaProfile = async (accessToken, x_token) => {
    const Backend_token = localStorage.getItem('Backend_token');
    try {
        const response = await axios.post(
            "/abdm/getAbhaprofile",
            {
                header: {
                    "Content-Type": "application/json",
                    "REQUEST-ID": uuidv4(),
                    "TIMESTAMP": new Date().toISOString(),
                    "X-token": "Bearer " + x_token,
                    'Authorization': 'Bearer ' + accessToken,
                },

            },
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${Backend_token}`,
                },
            }
        );
        return response.data;
    } catch (error) {
        console.error("Session Creation Error:", error);
        throw new Error("Failed to create session.");
    }
};

export const verifyUser = async (accessToken, x_token, abhano, txnId) => {
    const Backend_token = localStorage.getItem('Backend_token');
    try {
        const response = await axios.post(
            "/abdm/userVerify",
            {
                request :{
                    ABHANumber: abhano,
                    txnId: txnId,
                },
                header: {
                    "Content-Type": "application/json",
                    "REQUEST-ID": uuidv4(),
                    "TIMESTAMP": new Date().toISOString(),
                    "T-token": "Bearer " + x_token,
                    'Authorization': 'Bearer ' + accessToken,
                },
                
            },
            {
                headers: {
                    'Content-Type'  : 'application/json',
                    'Authorization' : `Bearer ${Backend_token}`,
                },
            }
        );
        return response.data;
    } catch (error) {
        console.error("Session Creation Error:", error);
        throw new Error("Failed to create session.");
    }
};
const saveLoggedInDetails = async (loggedinData, programType) => {
    try {
        const accessToken = localStorage.getItem('Backend_token');

        if (programType == 'NCD') {

            const response = await axios.post(`/saralapi/loginncd`, loggedinData,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${accessToken}`,
                    },
                }

            );

            if (response.data.code == 200) {
                localStorage.setItem("permissions", JSON.stringify(response.data.permission));
                localStorage.setItem("Backend_token", response.data.token);
            } else {
                console.log('error');
            }

        } else if (programType == 'SICKLE') {

            const response = await axios.post(`/saralapi/loginsickle`, loggedinData,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: `Bearer ${accessToken}`,
                    },
                }

            );

            if (response.data.code == 200) {
                localStorage.setItem("Backend_token", response.data.token);
            } else {
                console.log('error');
            }

        } else {
            console.log('No data save...');
        }

    } catch (error) {
        console.error(error);
    }
};

export const loggedInNCD = async (refresh_token) => {
    try {
        const formData = new FormData();

        formData.append("grant_type", "refresh_token");
        formData.append("refres_tohken", refresh_token);

        const response = await axios.post("/portal/cphc-auth/oauth/token", formData, {
            headers: { "Content-Type": "application/x-www-form-urlencoded" },
            auth: { username: "NCDBrowser", password: "SecureNCD" },
        });

        const newAccessToken = response.data.access_token;

        localStorage.setItem("NCD_token", newAccessToken); // Update stored access token
        localStorage.setItem("NCD_refresh_token", response.data.refresh_token);

        const username = response.data.username?response.data.username:response.data.user;

        localStorage.setItem("ncd_username", username);

        await saveLoggedInDetails(response.data, 'NCD');

    } catch (error) {
        console.log(error);
    }
}
/**
 * This function used to login PMNDP
 * @author: Nadeem Ahamad
 * 
 */
// const loignPMNDP = async (fromData) => {
//     try {
//       setIsLoading(true);

//       const formData = new FormData();
//       formData.append("username", fromData.email);
//       formData.append("password", fromData.password);

//       const response = await axios.post("/backend/api/v1/facility/login", formData, {
//         headers: {}
//       });
      
//       if (response.status === 200) {
//         const responseData = response.data.data;
//         localStorage.setItem("PMNDP_token", responseData.token);

//         await saveLoggedInDetails(responseData.user, 'PMNDP');

//         const userdetail = {
//           firstname: responseData.user?.name,
//           rolename: '',
//           facilitydetail: '',
//           username: responseData.user?.email,
//           stateCode: responseData.user?.state_id,
//           facilityTypeId: responseData.user?.facility_id,
//           InchargeMobile: responseData.user?.mobile
//         };

//         localStorage.setItem("loggedinUserdetails", JSON.stringify(userdetail));

//         localStorage.setItem("pmndp_username", responseData.user?.email);

//         await mapUsername('PMNDP');

//         navigate("/dashboard");
//       } else {

//         toast.error(response.data.message || "Invalid Email or Password", {
//           className: "custom-toast-error"
//         });

//       }
//     } catch (error) {
//         if(error.response?.data){
//           toast.error(error.response.data?.message || 'Username Or Password Incorrect', {
//             className: "custom-toast-error"
//           });
//         }else{
//           toast.error("Somthing Went Wrong ! Please try after some time", {
//             className: "custom-toast-error"
//           });
//         }

//     } finally {
//       setIsLoading(false);
//     }
// };
